"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureTransactionList = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _SectionHeader = _interopRequireDefault(require("../../components/SectionHeader"));
var _Transactions = _interopRequireDefault(require("../../components/Transactions"));
var _TransactionListStyled = require("./TransactionListStyled");
var _jsxRuntime = require("react/jsx-runtime");
const TransactionList = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TransactionListStyled.WrapStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
      marginTop: "25px",
      children: t('Transactions')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Transactions.default, {})]
  });
};
exports.PureTransactionList = TransactionList;
var _default = exports.default = TransactionList;